import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.track = this.$('track')[0];
        
    }

    init() {
        this.resize();
        this.bindResize = this.resize.bind(this);
        window.addEventListener('resize', this.bindResize);

    }

    resize() {
        this.el.style.height = `${this.track.getBoundingClientRect().width + window.innerHeight}px`;

    }

    destroy() {

        window.removeEventListener('resize', this.bindResize);

    }

}
